import { OverviewModuleComponent } from './overview-module/overview-module.component';
// import { ChangePasswordComponent } from './change-password/change-password.component';
import { CreditScoreComponent } from './credit-score/credit-score.component';
// import { ContactComponent } from './contact/contact.component';
// import { AuthguardService } from './config/authguard.service';
import { ForbiddenComponent } from './shared/error-pages/forbidden/forbidden.component';
import { NotFoundComponent } from './shared/error-pages/not-found/not-found.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { LoginComponent } from './login/login.component';
import { OverviewComponent } from './overview/overview.component';
import { ProfileComponent } from './profile/profile.component';
import { ReportsComponent } from './reports/reports.component';
// import { LoggedInAuthGuard } from './config/login-authguard.service';
import { ParkiteReportsComponent } from './parkite-reports/parkite-reports.component';

//new imports
import { ChangePasswordComponent } from 'src/app/_Shared/_Components/_Common/change-password/change-password.component';
import { ContactComponent } from 'src/app/_Shared/_Components/_Common/contact/contact.component';
import { LoginComponent } from 'src/app/_Shared/_Components/_Common/login/login.component';

import { AuthguardService } from 'src/app/_Core/_Guards/authguard.service';
import { LoggedInAuthGuard } from 'src/app/_Core/_Guards/login-authguard.service';
import { BridgePlusLoginGuard } from 'src/app/_Core/_Guards/bridge-plus-login.guard';
import { ParkiteLoginGuard } from 'src/app/_Core/_Guards/parkite-login.guard';
import { ProfileVerificationComponent } from './_Shared/_Components/_Generic/profile-verification/profile-verification/profile-verification.component';
import { OpenLinkGuard } from './_Core/_Guards/open-link.guard';


const routes: Routes = [
  //new routes
  // {
  //   path: 'change-password',
  //   component: ChangePasswordComponent,
  //   // // canActivate: [AuthguardService]
  // },
  // {
  //   path: 'contact',
  //   component: ContactComponent,
  //   // // canActivate: [AuthguardService],

  // },
  {
    path: 'vmsGuest',
    canActivate: [OpenLinkGuard], //need to open
    loadChildren: () => import(`../app/_Shared/_Components/_Generic/qrcode/qrcode.module`).then(m => m.QrcodeModule)
  },
  {
    path: 'userConsent',
    canActivate: [OpenLinkGuard], //need to open
    loadChildren: () => import(`../app/_Shared/_Components/_Generic/userconsent/userconsent.module`).then(m => m.UserconsentModule)
  },
  {
    path: 'verifyemail',
    canActivate: [OpenLinkGuard], //need to open
    component: ProfileVerificationComponent,
  },
  {
    path: '',
    canActivate: [OpenLinkGuard], //need to open
    children: [
      {
        path: '',
        component: LoginComponent,
        canActivate: [LoggedInAuthGuard] //need to open
      },
      {
        path: '',
        // loadChildren: () => import(`./_Modules/-bridge-plus/-bridge-plus.module`).then(m => m.BridgePlusModule),
        canActivate: [AuthguardService], //need to open
        children: [
          {
            path: '',
            loadChildren: function () {
              let userType = localStorage.getItem('userType');
              try {
                const tok = localStorage.getItem('token');
                if (tok) {
                  const parts = tok.split('.');
                  if (parts.length > 1) {
                    const payload = JSON.parse(atob(parts[1]));
                    if (payload?.userType) {
                      userType = payload.userType;
                    }
                  }
                }
              } catch {}
              if (userType === 'Bridge+') {
                return import(`./_Modules/-bridge-plus/-bridge-plus.module`).then(m => m.BridgePlusModule);
              }
              return import(`./_Modules/-parkite/-parkite.module`).then(m => m.ParkiteModule);
            }
          },
        ]
      },
    ]
  },
  // {
  //   path: 'overview', component: OverviewComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: '',
  //   component: LoginComponent,
  //   // // canActivate: [LoggedInAuthGuard]
  // },

  //old routes
  // {
  //   path: 'meeting',
  //   loadChildren: () => import('./meeting-room-TA/meeting-room.module').then(m => m.MeetingRoomModule),
  //   // // canActivate: [AuthguardService],
  // },
  // {
  //   path: 'employees',
  //   loadChildren: () => import('./employees-TA/employees.module').then(m => m.EmployeesModule),
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'vms',
  //   loadChildren: () => import('./vms/vms.module').then(m => m.VmsModule),
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'company',
  //   loadChildren: () => import('./company-module/company.module').then(m => m.CompanyModule),
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'overview', component: OverviewComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'overview-parkite', component: OverviewModuleComponent,
  //   // // canActivate: [AuthguardService],

  // },
  {
    path: 'login',
    redirectTo: '',
    pathMatch: 'full'
  },
  // {
  //   path: 'profile', component: ProfileComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'reports', component: ReportsComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'contact', component: ContactComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'credits', component: CreditScoreComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'change-password', component: ChangePasswordComponent,
  //   // // canActivate: [AuthguardService],

  // },
  // {
  //   path: 'parkite-reports',
  //   component: ParkiteReportsComponent,
  //   // // canActivate: [AuthguardService],
  // },
  {
    path: 'not-found',
    component: NotFoundComponent,
    canActivate: [OpenLinkGuard, AuthguardService],//need to open

  },
  {
    path: 'forbidden',
    component: ForbiddenComponent,
    canActivate: [OpenLinkGuard, AuthguardService],//need to open

  },
  // {
  //   path: '', component: LoginComponent,
  //   // // canActivate: [LoggedInAuthGuard]
  // },
  {
    path: ':id',
    component: LoginComponent,
    canActivate: [OpenLinkGuard],//need to open

  },
  {
    path: '**',
    redirectTo: '/not-found'
  }
  // {path: 'meeting/meetingroom-details', component: MeetingRoomDetailsComponent},
  // {path: 'meeting/meetingroom-list', component: MeetingRoomListComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
